import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{attrs:{"outlined":"","label":_vm.t('Purchase order')},model:{value:(_vm.purchase_order),callback:function ($$v) {_vm.purchase_order=$$v},expression:"purchase_order"}})}
var staticRenderFns = []

export { render, staticRenderFns }